fragment ContentBlockQuote on contentBlocks_quote_BlockType {
    quote: text
    author

    anchorId
    anchorLabel
}
